import React from 'react'

import { sendDiscoverMixpanelEvent } from '@disco/utils/mixpanel/discover-page'

import type { ClientLibraryDiscoveryPanelItem } from 'types/client-library'

import LibraryGridItem from 'components/common/library-grid-item'
import { Flex } from 'components/ds'

import CatalogTracksGrid from './components/track-grid'
import { useGetClientLibraryCatalogTracks } from './hooks'

const CatalogAndTrackSection = ({
  catalog,
  isFeatured,
  businessName,
}: {
  catalog: ClientLibraryDiscoveryPanelItem
  isFeatured?: boolean
  businessName?: string
}): React.ReactNode => {
  const { catalogTracks, isLoading, error } =
    useGetClientLibraryCatalogTracks(catalog)
  const tracks = catalogTracks[catalog.id] || []

  const catalogEventProps = {
    context: 'Discover Music Home',
    catalogId: catalog.id,
    catalogName: catalog.display_name || 'Untitled Catalog',
    catalogBusiness: businessName,
    isFeatured: isFeatured,
  } as const

  return (
    <Flex
      direction="column"
      gap="6"
      width="100%"
      minHeight="400px"
      maxWidth="535px"
    >
      <Flex direction="column" maxWidth="535px" width="100%">
        <LibraryGridItem
          lib={catalog}
          onClick={() => {
            sendDiscoverMixpanelEvent('Click Image', catalogEventProps)
          }}
          onVisitCatalog={() => {
            sendDiscoverMixpanelEvent('Click Button', {
              copy: 'Visit Catalog',
              ...catalogEventProps,
            })
          }}
        />
        <CatalogTracksGrid
          tracks={tracks}
          catalog={catalog}
          isLoading={isLoading}
          businessName={businessName}
          error={error}
        />
      </Flex>
    </Flex>
  )
}

export default CatalogAndTrackSection
